import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyB9pg-DhxTxhHBCUWJv-8nL-sxYNUJpaJ4",
  authDomain: "play-video-751b5.firebaseapp.com",
  projectId: "play-video-751b5",
  storageBucket: "play-video-751b5.appspot.com",
  messagingSenderId: "319999234987",
  appId: "1:319999234987:web:9ffdf3e1df158db31238ee",
  measurementId: "G-BMX8JLK1VT",
  ssl: true
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();
const db = getFirestore(app);

export const signInWithGoogle = async () => {
  try {
    const result = await signInWithPopup(auth, provider);
    return result.user;
  } catch (error) {
    console.error(error);
  }
};

export { db };